import { CheckCircle, Warning, ClockAfternoon, WarningCircle, Info } from 'phosphor-react';
import React from 'react';
import { twMerge } from 'tailwind-merge';

const AppPillStatus = ({
  status,
  wrapperClassName,
  label,
}: {
  status: 'SUCCESS' | 'DISABLED' | 'ERROR' | 'INFO' | 'WARNING';
  label: string;
  wrapperClassName?: string;
}) => {
  return (
    <div className={twMerge(' w-32', wrapperClassName || '')}>
      <div
        className={twMerge(
          'text-xs capitalize font-bold py-1.5 pl-3 rounded-full w-fit text-center flex items-center',
          status === 'SUCCESS'
            ? 'SUCCESS_100-BG SUCCESS_500-CLR'
            : status === 'DISABLED'
            ? 'GREY_100-BG GREY_500-CLR'
            : status === 'ERROR'
            ? 'ERROR_100-BG ERROR_500-CLR'
            : status === 'INFO'
            ? 'INFO_100-BG INFO_500-CLR'
            : status === 'WARNING'
            ? 'WARNING_100-BG WARNING_500-CLR'
            : ''
        )}>
        <div>
          {status === 'SUCCESS' && <CheckCircle size={14} weight="bold" />}
          {status === 'WARNING' && <WarningCircle size={14} weight="bold" />}
          {status === 'ERROR' && <Warning size={14} weight="bold" />}
          {status === 'DISABLED' && <ClockAfternoon size={14} weight="bold" />}
          {status === 'INFO' && <Info size={14} weight="bold" />}
        </div>
        <p className="mr-3 ml-1 capitalize font-medium"> {label}</p>
      </div>
    </div>
  );
};

export default AppPillStatus;
